const ITEMS = [
  "Precision Lawn Care",
  "Bespoke Gardens",
  "Interlock & Stone",
  "Seasonal Cleanups",
  "Snow & Ice Management",
  "Mulch & Planting",
];

export default function Marquee() {
  return (
    <div className="overflow-hidden border-y border-[#234E33]/15 bg-[#F4EFEA] py-5" data-testid="editorial-marquee">
      <div className="animate-marquee flex w-max">
        {[0, 1].map((copy) => (
          <div key={copy} className="flex shrink-0 items-center" aria-hidden={copy === 1}>
            {ITEMS.map((t) => (
              <span key={`${copy}-${t}`} className="flex items-center">
                <span className="px-7 font-display text-2xl italic text-[#234E33]">{t}</span>
                <span className="h-1.5 w-1.5 rounded-full bg-[#C86D51]" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
